(function () {
    var _carritoOpen = false;

    window.abrirModalCarrito = function () {
        document.getElementById('modal-carrito-overlay').classList.remove('hidden');
        var panel = document.getElementById('modal-carrito');
        panel.classList.remove('hidden');
        panel.style.display = 'flex';
        requestAnimationFrame(function () {
            panel.classList.remove('translate-x-full');
        });
        _carritoOpen = true;
        document.body.style.overflow = 'hidden';
        _cargarContenidoCarrito();
    };

    window.cerrarModalCarrito = function () {
        var panel = document.getElementById('modal-carrito');
        panel.classList.add('translate-x-full');
        setTimeout(function () {
            panel.classList.add('hidden');
            panel.style.display = '';
            document.getElementById('modal-carrito-overlay').classList.add('hidden');
        }, 300);
        _carritoOpen = false;
        document.body.style.overflow = '';
    };

    function _cargarContenidoCarrito() {
        var body = document.getElementById('modal-carrito-body');
        body.innerHTML =
            '<div class="flex-1 flex items-center justify-center text-gray-400 text-sm">' +
            '<svg class="animate-spin w-6 h-6 mr-2 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
            '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>' +
            '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>Cargando...</div>';
        fetch('/carrito-partial', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.text(); })
            .then(function (html) {
                body.innerHTML = html;
                if (typeof window.initCarritoModal === 'function') window.initCarritoModal();
            })
            .catch(function () {
                body.innerHTML = '<p class="p-6 text-center text-sm text-red-400">Error al cargar el carrito.</p>';
            });
    }

    window.recargarModalCarrito = function () {
        if (_carritoOpen) _cargarContenidoCarrito();
    };

    window._cargarContenidoCarrito = _cargarContenidoCarrito;

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _carritoOpen) cerrarModalCarrito();
    });
})();

// ── MODAL INFO MARGEN DE PESO ────────────────────────────────────────────────
(function () {
    var MARGEN = 12;

    window.abrirInfoMargenPeso = function (boton) {
        var modal = document.getElementById('modalInfoMargenPeso');
        if (!modal) return;
        var caja = modal.querySelector('[data-caja-info]') || modal.firstElementChild;

        modal.classList.remove('hidden');
        caja.style.position = '';
        caja.style.top = '';
        caja.style.left = '';

        if (!boton || window.innerWidth < 640) return;

        var r = boton.getBoundingClientRect();
        var c = caja.getBoundingClientRect();
        var left = r.left + r.width / 2 - c.width / 2;
        var top = r.bottom + MARGEN;

        if (top + c.height > window.innerHeight - MARGEN) {
            top = r.top - c.height - MARGEN;
        }
        if (top < MARGEN) top = MARGEN;
        left = Math.min(Math.max(left, MARGEN), window.innerWidth - c.width - MARGEN);

        caja.style.position = 'fixed';
        caja.style.top = top + 'px';
        caja.style.left = left + 'px';
    };

    window.cerrarInfoMargenPeso = function () {
        var modal = document.getElementById('modalInfoMargenPeso');
        if (!modal) return;
        var caja = modal.querySelector('[data-caja-info]') || modal.firstElementChild;
        caja.style.position = '';
        caja.style.top = '';
        caja.style.left = '';
        modal.classList.add('hidden');
    };
})();

// ── MODAL PROCESAR ───────────────────────────────────────────────────────────
(function () {
    var _procesarOpen = false;

    window.abrirModalProcesar = function () {
        document.getElementById('modal-procesar-overlay').classList.remove('hidden');
        var panel = document.getElementById('modal-procesar');
        panel.classList.remove('hidden');
        panel.style.display = 'flex';
        requestAnimationFrame(function () {
            panel.classList.remove('translate-x-full');
        });
        _procesarOpen = true;
        document.body.style.overflow = 'hidden';
        _cargarContenidoProcesar();
    };

    window.cerrarModalProcesar = function () {
        var panel = document.getElementById('modal-procesar');
        panel.classList.add('translate-x-full');
        setTimeout(function () {
            panel.classList.add('hidden');
            panel.style.display = '';
            document.getElementById('modal-procesar-overlay').classList.add('hidden');
        }, 300);
        _procesarOpen = false;
        document.body.style.overflow = '';
    };

    function _cargarContenidoProcesar() {
        var body = document.getElementById('modal-procesar-body');
        body.innerHTML =
            '<div class="flex-1 flex items-center justify-center text-gray-400 text-sm">' +
            '<svg class="animate-spin w-6 h-6 mr-2 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
            '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>' +
            '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>Cargando...</div>';
        fetch('/procesar-partial', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.text();
            })
            .then(function (html) {
                body.innerHTML = html;
                // Execute inline scripts from the partial
                body.querySelectorAll('script').forEach(function (oldScript) {
                    var newScript = document.createElement('script');
                    newScript.textContent = oldScript.textContent;
                    document.head.appendChild(newScript);
                    newScript.remove();
                });
            })
            .catch(function (err) {
                if (String(err).includes('422')) {
                    body.innerHTML = '<p class="p-6 text-center text-sm text-red-400">No se puede tramitar el pedido. Revisa tu carrito.</p>';
                } else {
                    body.innerHTML = '<p class="p-6 text-center text-sm text-red-400">Error al cargar. Inténtalo de nuevo.</p>';
                }
            });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _procesarOpen) cerrarModalProcesar();
    });
})();

// ── MODAL PAGO ───────────────────────────────────────────────────────────────
(function () {
    var _pagoOpen = false;

    window.abrirModalPago = function () {
        document.getElementById('modal-pago-overlay').classList.remove('hidden');
        var panel = document.getElementById('modal-pago');
        panel.classList.remove('hidden');
        panel.style.display = 'flex';
        requestAnimationFrame(function () {
            panel.classList.remove('translate-x-full');
        });
        _pagoOpen = true;
        document.body.style.overflow = 'hidden';
        _cargarContenidoPago();
    };

    window.cerrarModalPago = function () {
        var panel = document.getElementById('modal-pago');
        panel.classList.add('translate-x-full');
        setTimeout(function () {
            panel.classList.add('hidden');
            panel.style.display = '';
            document.getElementById('modal-pago-overlay').classList.add('hidden');
        }, 300);
        _pagoOpen = false;
        document.body.style.overflow = '';
    };

    function _cargarContenidoPago() {
        var body = document.getElementById('modal-pago-body');
        body.innerHTML =
            '<div class="flex-1 flex items-center justify-center text-gray-400 text-sm">' +
            '<svg class="animate-spin w-6 h-6 mr-2 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
            '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>' +
            '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>Cargando...</div>';
        fetch('/pago-partial', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.text();
            })
            .then(function (html) {
                body.innerHTML = html;
                // Remove any Paycomet SDK <script> left in <head> from a previous modal open.
                // The SDK binds window.onmessage and its iframe references globally on load, so
                // leaving stale copies around risks one finishing (from cache) after the current
                // one and rebinding those globals to already-destroyed DOM/iframes.
                document.querySelectorAll('script[data-paycomet-sdk]').forEach(function (s) { s.remove(); });
                // Re-execute scripts from partial in order: inline first, then external (SDK).
                // Inline scripts run synchronously; external scripts (Paycomet SDK) load async
                // but document.currentScript is valid because they are added via <script src>.
                var scripts = Array.from(body.querySelectorAll('script'));
                scripts.forEach(function (oldScript) {
                    var newScript = document.createElement('script');
                    if (oldScript.src) {
                        newScript.src = oldScript.src;
                        if (oldScript.src.indexOf('paycomet') !== -1) newScript.setAttribute('data-paycomet-sdk', '1');
                    } else {
                        newScript.textContent = oldScript.textContent;
                    }
                    document.head.appendChild(newScript);
                    if (!oldScript.src) newScript.remove();
                });
            })
            .catch(function () {
                body.innerHTML = '<p class="p-6 text-center text-sm text-red-400">Error al cargar el pago. Inténtalo de nuevo.</p>';
            });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _pagoOpen) cerrarModalPago();
    });
})();

window.togglePers = function (id) {
    var el = document.getElementById(id);
    var chevron = document.getElementById(id + '-chevron');
    var btn = document.getElementById(id + '-btn');
    if (!el || !chevron || !btn) return;
    var isOpen = el.style.display !== 'none';
    el.style.display = isOpen ? 'none' : 'block';
    chevron.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    btn.style.borderRadius = isOpen ? '8px' : '8px 8px 0 0';
};

window.initCarritoModal = function () {
    _initSwipeToDelete();
};

function _initSwipeToDelete() {
    var REVEAL = 90; // px — width of delete panel
    var THRESHOLD = 40; // min drag to snap open

    document.querySelectorAll('.carrito-swipe-wrapper').forEach(function (wrapper) {
        var item   = wrapper.querySelector('.carrito-swipe-item');
        var panel  = wrapper.querySelector('.carrito-delete-panel');
        var btn    = wrapper.querySelector('.carrito-delete-btn');
        var url    = wrapper.dataset.eliminarUrl;
        if (!item || !panel || !btn) return;

        var trashBtn = wrapper.querySelector('.carrito-trash-btn');
        var startX = 0, currentX = 0, dragging = false, open = false;

        function setPos(x, animate) {
            item.style.transition  = animate ? 'transform .2s ease' : 'none';
            panel.style.transition = animate ? 'transform .2s ease' : 'none';
            item.style.transform   = 'translateX(' + x + 'px)';
            panel.style.transform  = 'translateX(' + (x + REVEAL) + 'px)';
        }

        function snapOpen()  { setPos(-REVEAL, true); open = true; }
        function snapClose() { setPos(0, true);        open = false; }

        // Touch
        item.addEventListener('touchstart', function (e) {
            startX   = e.touches[0].clientX;
            dragging = true;
        }, { passive: true });

        item.addEventListener('touchmove', function (e) {
            if (!dragging) return;
            var dx = e.touches[0].clientX - startX;
            if (open) dx -= REVEAL;
            dx = Math.min(0, Math.max(-REVEAL, dx));
            setPos(dx, false);
        }, { passive: true });

        item.addEventListener('touchend', function (e) {
            if (!dragging) return;
            dragging = false;
            var dx = e.changedTouches[0].clientX - startX;
            if (open) { if (dx > THRESHOLD) snapClose(); else snapOpen(); }
            else       { if (-dx > THRESHOLD) snapOpen();  else snapClose(); }
        });

        // Mouse (desktop)
        item.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return;
            startX   = e.clientX;
            dragging = true;
            e.preventDefault();
        });

        document.addEventListener('mousemove', function (e) {
            if (!dragging) return;
            var dx = e.clientX - startX;
            if (open) dx -= REVEAL;
            dx = Math.min(0, Math.max(-REVEAL, dx));
            setPos(dx, false);
        });

        document.addEventListener('mouseup', function (e) {
            if (!dragging) return;
            dragging = false;
            var dx = e.clientX - startX;
            if (open) { if (dx > THRESHOLD) snapClose(); else snapOpen(); }
            else       { if (-dx > THRESHOLD) snapOpen();  else snapClose(); }
        });

        // Close open item when tapping elsewhere
        document.addEventListener('touchstart', function (e) {
            if (open && !wrapper.contains(e.target)) snapClose();
        }, { passive: true });

        // Trash icon → auto-slide open
        if (trashBtn) {
            trashBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                if (open) snapClose(); else snapOpen();
            });
        }

        // Delete button (red panel)
        btn.addEventListener('click', function () {
            var csrf = document.querySelector('meta[name="csrf-token"]');
            var token = csrf ? csrf.getAttribute('content') : '';
            btn.disabled = true;
            fetch(url, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': token,
                },
            })
            .then(function (r) { return r.json(); })
            .then(function (res) {
                if (!res.success) { btn.disabled = false; return; }
                var storeId = wrapper.dataset.store;

                // Animate out then remove item
                wrapper.style.transition = 'opacity .2s, max-height .3s';
                wrapper.style.overflow   = 'hidden';
                wrapper.style.opacity    = '0';
                wrapper.style.maxHeight  = wrapper.offsetHeight + 'px';
                requestAnimationFrame(function () {
                    wrapper.style.maxHeight = '0';
                });
                setTimeout(function () {
                    wrapper.remove();

                    // Update store block
                    var storeBlock  = document.getElementById('store-block-' + storeId);
                    var storeItems  = storeBlock ? storeBlock.parentElement.querySelectorAll('.carrito-swipe-wrapper[data-store="' + storeId + '"]') : [];
                    if (storeBlock && storeItems.length === 0) {
                        storeBlock.remove();
                    } else if (storeBlock) {
                        var countEl = document.getElementById('store-count-' + storeId);
                        if (countEl) {
                            var n = storeItems.length;
                            countEl.textContent = '· ' + n + ' ' + (n === 1 ? 'producto' : 'productos');
                        }
                    }

                    // Update nav badge
                    var navBadge = document.getElementById('cantidadCarritoNav');
                    if (navBadge) {
                        var current = parseInt(navBadge.textContent) || 0;
                        navBadge.textContent = Math.max(0, current - 1);
                    }

                    // Update header count
                    var remaining = document.querySelectorAll('.carrito-swipe-wrapper').length;
                    var headerEl = document.querySelector('#modal-carrito-body h2');
                    if (headerEl) headerEl.textContent = 'Mi carrito (' + remaining + ')';
                    if (remaining === 0) {
                        window._cargarContenidoCarrito();
                        return;
                    }

                    // Recalculate totals
                    _carritoActualizarTotales();
                }, 320);
            })
            .catch(function () { btn.disabled = false; });
        });
    });
}

function _carritoData(id) {
    var el = document.getElementById('data-' + id);
    if (!el) return null;
    return {
        id:        parseInt(el.dataset.id),
        cantidad:  parseFloat(el.dataset.cantidad),
        tipo:      el.dataset.tipo,
        step:      parseFloat(el.dataset.step),
        min:       parseFloat(el.dataset.min),
        medidas:   JSON.parse(el.dataset.medidas),
        pesoAprox: parseFloat(el.dataset.pesoAprox || 0),
    };
}

function _carritoAdmiteDecimales(tipo, min, step) {
    if (tipo !== 'Unidades') return true;
    return (!isNaN(min) && !Number.isInteger(min)) || (!isNaN(step) && !Number.isInteger(step));
}

function _carritoFormatea(cantidad, tipo, min, step) {
    if (!_carritoAdmiteDecimales(tipo, min, step)) return Math.round(cantidad);
    return parseFloat(cantidad.toFixed(3));
}

// Devuelve el valor de display (número en kg o ud.) para un tipo+cantidad internos
function _carritoDisplayValue(cantidad, tipo) {
    if (tipo === 'gramos') return parseFloat((cantidad / 1000).toFixed(3));
    if (tipo === 'Kg')     return parseFloat(cantidad.toFixed(3));
    return cantidad; // Unidades: entero
}

function _carritoUpdateDisplay(id, cantidad, tipo) {
    var cantEl = document.getElementById('cant-' + id);
    if (!cantEl) return;
    cantEl.value = _carritoDisplayValue(cantidad, tipo);
}

// Convierte valor escrito en el input (en kg/ud display) a cantidad interna
window.carritoInputCantidad = function(id, valorDisplay) {
    var d = _carritoData(id);
    if (!d) return;

    var val = parseFloat(String(valorDisplay).replace(',', '.'));
    if (isNaN(val) || val <= 0) {
        // Valor inválido: restaurar display con valor actual
        _carritoUpdateDisplay(id, d.cantidad, d.tipo);
        return;
    }

    // El input muestra kg para gramos/Kg, y unidades para Unidades
    // Convertir display → cantidad interna
    var cantidadInterna;
    if (d.tipo === 'gramos') {
        cantidadInterna = parseFloat((val * 1000).toFixed(0)); // kg → gramos
    } else if (d.tipo === 'Kg') {
        cantidadInterna = parseFloat(val.toFixed(3));
    } else {
        cantidadInterna = _carritoFormatea(val, d.tipo, d.min, d.step);
    }

    // Aplicar mínimo
    if (d.min > 0 && cantidadInterna < d.min) cantidadInterna = d.min;

    // Ajustar al step más cercano
    if (d.step > 0) {
        var base = d.min > 0 ? d.min : 0;
        cantidadInterna = base + Math.round((cantidadInterna - base) / d.step) * d.step;
        cantidadInterna = _carritoFormatea(cantidadInterna, d.tipo, d.min, d.step);
    }

    _carritoUpdateDisplay(id, cantidadInterna, d.tipo);
    _carritoGuardar(id, cantidadInterna, d.tipo);
};

function _fmtPrice(n) {
    return parseFloat(n).toFixed(2).replace('.', ',');
}

function _carritoActualizarTotales() {
    var totalProductos = 0;
    var totalManipulacion = 0;

    var dataDivs = document.querySelectorAll('[id^="data-"]');
    var porTienda = {};
    dataDivs.forEach(function (el) {
        var store = el.dataset.store;
        if (!store) return;
        if (!porTienda[store]) {
            porTienda[store] = {
                ids:          [],
                costeManip:   parseFloat(el.dataset.costeManipulacion || 0),
                pedidoMinimo: parseFloat(el.dataset.pedidoMinimo || 0),
            };
        }
        porTienda[store].ids.push(el.dataset.id);
    });

    Object.keys(porTienda).forEach(function (store) {
        var info = porTienda[store];

        var storeProductos = 0;
        info.ids.forEach(function (itemId) {
            var precioEl = document.getElementById('precio-' + itemId);
            if (precioEl) {
                var txt = precioEl.textContent.replace('€', '').replace(',', '.').trim();
                storeProductos += parseFloat(txt) || 0;
            }
        });

        var manip = 0;
        if (info.costeManip > 0 && info.pedidoMinimo > 0 && storeProductos < info.pedidoMinimo) {
            manip = info.costeManip;
        }

        info.ids.forEach(function (itemId) {
            var el = document.getElementById('data-' + itemId);
            if (el) el.dataset.manipulacion = manip;
        });

        var manipRow = document.getElementById('store-manip-row-' + store);
        if (manipRow) {
            if (manip > 0) {
                manipRow.style.display = '';
                var manipValor = document.getElementById('store-manip-valor-' + store);
                if (manipValor) manipValor.textContent = _fmtPrice(manip) + '€';
            } else {
                manipRow.style.display = 'none';
            }
        }

        var storeTotal = storeProductos + manip;
        totalProductos += storeProductos;
        totalManipulacion += manip;

        var storeEl = document.getElementById('store-subtotal-' + store);
        if (storeEl) storeEl.textContent = _fmtPrice(storeTotal) + '€';
    });

    var fpEl = document.getElementById('footer-productos');
    if (fpEl) fpEl.textContent = _fmtPrice(totalProductos) + '€';

    var fmEl = document.getElementById('footer-manipulacion');
    if (fmEl) fmEl.textContent = _fmtPrice(totalManipulacion) + '€';
    var fmRow = document.getElementById('footer-manipulacion-row');
    if (fmRow) fmRow.style.display = totalManipulacion > 0 ? '' : 'none';

    var fsEl = document.getElementById('footer-subtotal');
    if (fsEl) fsEl.textContent = _fmtPrice(totalProductos + totalManipulacion) + '€';
}

var _carritoGuardarTimer = null;
function _carritoGuardar(id, cantidad, tipo) {
    var dataEl = document.getElementById('data-' + id);
    if (!dataEl) return;
    dataEl.dataset.cantidad = cantidad;
    dataEl.dataset.tipo = tipo;

    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    var token = csrfToken ? csrfToken.getAttribute('content') : '';

    clearTimeout(_carritoGuardarTimer);
    _carritoGuardarTimer = setTimeout(function () {
        fetch('/actualizar-item-carrito', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': token,
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ id: id, cantidad: cantidad, tipo_cantidad: tipo }),
        })
            .then(function (r) { return r.json(); })
            .then(function (data) {
                var precioEl = document.getElementById('precio-' + id);
                if (precioEl && data.precio_final !== undefined) {
                    precioEl.textContent = _fmtPrice(data.precio_final) + '€';
                }
                _carritoActualizarTotales();
            })
            .catch(function () {});
    }, 350);
}

window.carritoStep = function (id, dir) {
    var d = _carritoData(id);
    if (!d) return;
    var nueva = d.cantidad + dir * d.step;
    if (nueva < d.min) nueva = d.min;
    nueva = _carritoFormatea(nueva, d.tipo, d.min, d.step);
    _carritoUpdateDisplay(id, nueva, d.tipo);
    _carritoGuardar(id, nueva, d.tipo);
};

function _carritoConvertir(cantidad, desdeTipo, haciaTipo, pesoAprox, min, step) {
    if (desdeTipo === haciaTipo) return cantidad;
    var gramos;
    if (desdeTipo === 'gramos')  gramos = cantidad;
    else if (desdeTipo === 'Kg') gramos = cantidad * 1000;
    else                         gramos = cantidad * pesoAprox * 1000;

    if (haciaTipo === 'gramos') return parseFloat(gramos.toFixed(0));
    if (haciaTipo === 'Kg')     return parseFloat((gramos / 1000).toFixed(3));

    var minUnidades = min > 0 ? min : 1;
    if (pesoAprox <= 0) return minUnidades;
    var unidades = gramos / (pesoAprox * 1000);
    return Math.max(minUnidades, _carritoFormatea(unidades, haciaTipo, min, step));
}

window.carritoChangeUnidad = function (id, nuevoTipo) {
    var dataEl = document.getElementById('data-' + id);
    if (!dataEl) return;
    var medidas       = JSON.parse(dataEl.dataset.medidas);
    var cfg           = medidas[nuevoTipo] || { min: 0, step: nuevoTipo === 'Unidades' ? 1 : 0.250 };
    var pesoAprox     = parseFloat(dataEl.dataset.pesoAprox || 0);
    var cantidadActual = parseFloat(dataEl.dataset.cantidad);
    var tipoActual     = dataEl.dataset.tipo;

    var cantidadConvertida = _carritoConvertir(cantidadActual, tipoActual, nuevoTipo, pesoAprox, cfg.min, cfg.step);
    cantidadConvertida = Math.max(cantidadConvertida, cfg.min);
    cantidadConvertida = _carritoFormatea(cantidadConvertida, nuevoTipo, cfg.min, cfg.step);

    dataEl.dataset.tipo     = nuevoTipo;
    dataEl.dataset.step     = cfg.step;
    dataEl.dataset.min      = cfg.min;
    dataEl.dataset.cantidad = cantidadConvertida;

    _carritoUpdateDisplay(id, cantidadConvertida, nuevoTipo);
    _carritoGuardar(id, cantidadConvertida, nuevoTipo);
};

window.editarItemCarrito = function (carroId, mercadoId, productoId, cantidad, tipoCantidad, finalizacion, preparacion, indicaciones) {
    window._editandoCarroId = carroId;
    window.modalProducto(mercadoId, productoId);

    var observer = new MutationObserver(function (mutations, obs) {
        var btnContainer = document.getElementById('modal-footer-btn-container');
        if (!btnContainer || !btnContainer.querySelector('button')) return;
        obs.disconnect();

        setTimeout(function () {
            var $tipoCant = $('#tipo_cantidad');
            if ($tipoCant.find('option[value="' + tipoCantidad + '"]').length) {
                $tipoCant.val(tipoCantidad);
                if (typeof window.cambiotipo === 'function') window.cambiotipo();
            }
            $('#cantidad').val(cantidad);
            if (typeof window.ajusta_precio === 'function') window.ajusta_precio();

            if (finalizacion) {
                var $fin = $('#finalizacion');
                if ($fin.length) $fin.val(finalizacion);
            }

            if (preparacion) {
                var preps = preparacion.split(';');
                $('input[name="preparations"]').each(function () {
                    $(this).prop('checked', preps.indexOf($(this).val()) !== -1);
                });
            }

            if (indicaciones) $('#indicaciones').val(indicaciones);

            btnContainer.innerHTML =
                '<button onclick="guardarEdicionCarrito();" type="button" id="additembutton"' +
                ' class="w-full flex items-center justify-between px-5 py-3 rounded-full text-white font-semibold text-sm transition hover:opacity-90"' +
                ' style="background-color:#1d7383;"><span>Guardar cambios</span></button>';
        }, 50);
    });

    var btnContainer = document.getElementById('modal-footer-btn-container');
    if (btnContainer) observer.observe(btnContainer, { childList: true, subtree: true });
};

window.guardarEdicionCarrito = function () {
    var carroId = window._editandoCarroId;
    if (!carroId) return;

    var btn = document.getElementById('additembutton');
    if (btn) btn.innerHTML = 'Guardando...';

    var checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    var preparacion = Array.from(checkboxes).map(function (c) { return c.value; }).join(';');
    var prepInput = document.getElementById('preparacion');
    if (prepInput) prepInput.value = preparacion;

    var cantidad     = parseFloat($('#cantidad').val()) || 0;
    var tipoCantidad = $('#tipo_cantidad').val() || '';
    var finalizacion = $('#finalizacion').val() || '';
    var indicaciones = $('#indicaciones').val() || '';

    var token = document.querySelector('meta[name="csrf-token"]');
    var csrfToken = token ? token.getAttribute('content') : '';

    fetch('/actualizar-item-completo/' + carroId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
            cantidad:     cantidad,
            tipo_cantidad: tipoCantidad,
            finalizacion: finalizacion,
            preparacion:  preparacion,
            indicaciones: indicaciones,
        }),
    })
        .then(function (r) { return r.json(); })
        .then(function (data) {
            var savedCarroId = carroId;
            window._editandoCarroId = null;
            window.cerrarModalAddCart();
            document.body.style.overflow = 'hidden';

            if (data.precio_final !== undefined) {
                var precioEl = document.getElementById('precio-' + savedCarroId);
                if (precioEl) precioEl.textContent = _fmtPrice(data.precio_final) + '€';
            }
            if (data.cantidad !== undefined && data.tipo_cantidad !== undefined) {
                var dataEl = document.getElementById('data-' + savedCarroId);
                if (dataEl) {
                    dataEl.dataset.cantidad = data.cantidad;
                    dataEl.dataset.tipo = data.tipo_cantidad;
                }
                _carritoUpdateDisplay(savedCarroId, data.cantidad, data.tipo_cantidad);
            }
            _carritoActualizarTotales();
        })
        .catch(function () {
            if (btn) btn.innerHTML = 'Error, intenta de nuevo';
        });
};
